import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/auth.guard';
import { MainLayoutComponent } from '@app/layout/main-layout/main-layout.component';
import { FacesheetComponent } from './facesheet/facesheet.component';
import { InfoComponent } from './info/info.component';

const routes: Routes = [
  {
    path: 'basic',
    component: MainLayoutComponent,
    // resolve: { menuList: MenuResolverService, userList: UserListResolverService },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'facesheet/:menuGroupId/:menuid/:type/:objcd/:ttlkbn/:ttlcd',
        component: FacesheetComponent,
      },
      {
        path: 'info/:menuGroupId/:menuid/:type',
        component: InfoComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BasicRoutingModule { }
